
import {
  schema, normalize
} from 'normalizr'

import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'

// Define answer schema
const videosSchema = new schema.Entity('videos')
const videosListSchema = [videosSchema]

export function adaptVideosToStore({ data }) {
  const entries = normalize(data.results, videosListSchema)
  return {
    entries: entries.entities.videos,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptVideoToApi(video = {}) {
  let payload = {
    name: video.name,
    s3_video_url: video.source,
    duration_in_seconds: video.duration_in_seconds,
    jwplayer_id: video.jwplayer_id,
    slug: video.slug,
    metadata: {
      company: video.company.toLowerCase()
    },
    files: video.files,
    type: video.type
  }
  payload = omitBy(payload, isNil)
  //Can send null value
  payload.instructor_id = video.instructor_id
  return payload
}

export function adaptVideoToStore({ data }) {
  return {
    id: data.id,
    name: data.name,
    source: data.s3_video_url,
    duration_in_seconds: data.duration_in_seconds,
    jwplayer_id: data.jwplayer_id,
    slug: data.slug,
    created: data.created,
    modified: data.modified,
    status: data.status,
    metadata: data.metadata,
    instructor_id: data.instructor_id,
    files: data.files,
    type: data.type
  }
}